// @flow
import React from 'react';
import {Link} from 'react-router-dom';
import {IconButton, Typography, makeStyles} from '@material-ui/core';
import {ArrowBack} from '@material-ui/icons';

import type {Theme} from '@material-ui/core';

type Props = {
  to: string,
  label: string,
};

const useStyles = makeStyles((theme: Theme) => ({
  title: {
    fontSize: 18,
    fontWeight: 600,
  },
  wrap: {
    display: 'flex',
    gap: '8px',
  },
}));

export default function BackSectionButton({to, label}: Props) {
  const classes = useStyles();
  return (
    <div className={classes.wrap}>
      <Link to={to}>
        <IconButton variant="contained" size="small">
          <ArrowBack />
        </IconButton>
      </Link>
      <Typography className={classes.title}>{label}</Typography>
    </div>
  );
}
